<div class="main surface-ground pb-4" style="min-height: calc(100vh - 80px);">
  <div class="container-layout pt-3">
    <!-- Breadcrumb -->
    <div class="mb-3">
    <app-breadcrumb-default [items]="items" [respectOrganizerContext]="true" />
  </div>

    <!-- Header da Busca: só faz sentido quando existe um termo pesquisado -->
    @if (searchText) {
      <div class="surface-card p-3 md:p-4 shadow-2 border-round mb-3 md:mb-4">
        <div class="flex flex-column md:flex-row md:align-items-center justify-content-between gap-2 md:gap-3">
          <div class="flex flex-column gap-2 min-w-0">
            <div class="flex align-items-center gap-2 min-w-0 flex-wrap">
              <div class="filter-icon flex align-items-center justify-content-center flex-shrink-0">
                <i class="pi pi-search"></i>
              </div>
              <span class="text-base md:text-xl text-500 white-space-nowrap">Procurar por:</span>
              <h1 class="text-xl md:text-3xl font-bold text-primary m-0 break-word line-height-2">{{ searchText }}</h1>
            </div>

            @if (exibirTelaPrincipal) {
              <div class="mt-1 md:mt-2">
                <span class="inline-flex align-items-center bg-primary-50 text-primary-700 px-2 py-1 border-round-2xl text-xs md:text-sm font-medium">
                  <i class="pi pi-search mr-2 text-xs"></i>
                  {{ eventosEncontrados }} {{ eventosEncontrados === 1 ? 'resultado encontrado' : 'resultados encontrados' }}
                </span>
              </div>
            }
          </div>

          <button
            pButton
            pRipple
            type="button"
            label="Limpar busca"
            icon="pi pi-times"
            class="p-button-text p-button-sm p-button-secondary w-fit align-self-start md:align-self-auto md:w-auto"
            (click)="clearSearchAndGoHome()">
          </button>
        </div>
      </div>
    }

    <!-- Conteúdo Principal -->
    @if (exibirTelaPrincipal) {
      <div class="grid grid-nogutter mb-4 animate-fade-in mt-4">
        <div class="col-12">
          <div class="flex flex-wrap gap-4">
      @for (event of pagedEvents; track trackByEvent(i, event); let i = $index) {
              <div class="w-full sm:w-auto">
          <app-card-event [id]="i"
          [card]="{
            src: event.src,
            day: event.day,
            title: event.title,
            month: event.month,
            city: event.city,
            state: event.state,
            description: event.description
          }"
                  width="16rem"
                  height="22rem"
                  borderRadius="1rem"
            [route]="['/eventos/detalhe', event.slugUrl]"
           />
        </div>
      }
    </div>
        </div>
    </div>

      <!-- Paginação e Ações -->
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-3 mt-5 pt-3 border-top-1 surface-border">
        <button 
          pButton 
          icon="pi pi-arrow-left" 
          label="Voltar" 
          class="p-button-text p-button-secondary font-medium" 
          (click)="back()">
        </button>

    @if (allEvents.length > 10) {
        <p-paginator [rows]="10"
          [totalRecords]="allEvents.length"
          [rowsPerPageOptions]="[10, 20, 30]"
          (onPageChange)="onPageChange($event)"
            styleClass="surface-transparent border-none p-0"
         />
        }
      </div>
    } @else {
      <!-- Estado Vazio -->
      <div class="surface-card border-round shadow-1 p-4 md:p-6 text-center animate-fade-in mt-4 w-full">
        <div class="bg-orange-50 border-circle w-5rem h-5rem md:w-6rem md:h-6rem flex align-items-center justify-content-center mx-auto mb-3 md:mb-4">
          <i class="pi pi-search text-4xl md:text-5xl text-orange-500"></i>
        </div>
        <h2 class="text-xl md:text-2xl font-bold text-900 mb-2">Nenhum resultado encontrado</h2>
        <p class="text-600 line-height-3 text-sm md:text-base mb-4 md:mb-5 max-w-30rem mx-auto">
          @if (searchText) {
            Não conseguimos encontrar eventos para "<strong>{{ searchText }}</strong>".<br>
            Verifique a ortografia ou tente palavras-chave diferentes.
          } @else {
            No momento não há eventos disponíveis para exibir.
          }
        </p>
        <button
          pButton
          pRipple
          class="p-button-primary p-button-rounded px-4 py-3 w-full sm:w-auto"
          (click)="clearSearchAndGoHome()">
          <i class="pi pi-refresh mr-2"></i>
          <span class="font-bold">{{ searchText ? 'Limpar busca e ver tudo' : 'Ver todos os eventos' }}</span>
        </button>
      </div>
    }

    <!-- Seção de Destaques (Sugestões) -->
    @if (featuredEvents.length > 0) {
      <div class="mt-5 mb-4 animate-fade-in">
        <div class="flex align-items-center gap-3 mb-2">
          <h2 class="text-xl font-bold m-0 text-800 border-left-2 border-orange-500 pl-3">
            Também pode te interessar
          </h2>
          <div class="flex-1 border-bottom-1 surface-border"></div>
        </div>
        
          <app-card-carousel [section]="'featured'"
          [numVisible]="4"
          [numScroll]="1"
            [events]="featuredEvents"
           />
      </div>
    }
    </div>
</div>
